<template>
  <div class="card">
    <header class="card-header">
      <div class="card-header-icon">
        <button @click="$parent.close()" class="delete is-large"></button>
      </div>
    </header>
    <div class="card-content">
      <div class="columns is-centered">
        <div class="column is-one-quarter">
          <b-button @click="reset" icon-left="redo">
            {{ $t("Reset") }}
          </b-button>
        </div>
        <div class="column is-one-quarter">
          <b-button @click="setFilter" type="is-date" icon-left="plus">
            {{ $t("Set") }}
          </b-button>
        </div>
      </div>
      <b-table
        :data="this.items"
        :paginated="true"
        :hoverable="true"
        :checked-rows.sync="checkedRows"
        checkable
        :per-page="itemsPerPage"
        :columns="columns"
      >
      </b-table>
    </div>
  </div>
</template>

<style scoped>
.center {
  text-align: center;
}
table tr:hover td {
  color: white !important;
}
</style>

<script>
import omit from "lodash/omit";

export default {
  data() {
    return {
      itemsPerPage: 10,
      selected: null,
      checkedRows: [],
      columns: [
        {
          field: "value",
          label: this.$t(this.label),
          sortable: true,
          searchable: true,
        },
        {
          field: "count",
          label: this.$t("Results"),
          sortable: true,
        },
      ],
    };
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    // name for url param
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  watch: {
    "$route.query": {
      handler(query) {
        const value = query[this.name];

        if (this.isValid(value)) {
          this.selected =
            this.items.filter((item) => item.key == value).pop() || null;
        }
      },
      immediate: true,
    },
    selected(item) {
      let query = { ...this.$route.query };
      if (item !== null) {
        query[this.name] = item;
      } else {
        query = omit(query, this.name);
      }
      this.$router.push({ query });
    },
  },
  methods: {
    select(item) {
      this.selected = item.value;
      this.$emit("closeModal", item.value);
    },
    setFilter() {
      let query = { ...this.$route.query };
      var labelArr = [];
      for (var itemIndex in this.checkedRows) {
        var item = this.checkedRows[itemIndex];
        labelArr.push(item.value);
      }
      if (labelArr.length > 0) {
        query[this.name] = labelArr;
      } else {
        query = omit(query, this.name);
      }
      this.$router.push({ query });
      this.$emit("closeModal", labelArr);
    },
    isValid(value) {
      // NOTE: does not check for correct type
      return this.items.some((item) => item == value);
    },
    reset() {
      let query = { ...this.$route.query };
      query = omit(query, this.name);

      this.$router.push({ query });
      this.$emit("closeModal", [this.label]);
    },
  },
};
</script>
